<template>
  <div class="container area-slides" v-if="data.length > 0">
    <swiper ref=""
      :slides-per-view="setting.slidesPerView"
      :slides-per-group="setting.slidesPerGroup"
      :centered-slides="setting.centeredSlides"
      :breakpoints="setting.breakpoints"
      :observeParents="setting.observeParents"
      :observer="setting.observer"
      :space-between="setting.spaceBetween"
      :loop="setting.loop"
      :pagination="setting.pagination"
      :navigation="false"
      :scrollbar="setting.scrollbar"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >

        <template v-if="content == 'CategoryContent'">
            <swiper-slide
                v-for="(item,index) in data"
                :key="item.value"
                :style="(setting.slidesPerView == 'auto' ? 'width: auto;' : '')"
            >
                <!-- <div class="item-category" :class="{act : activeIndex == index}" @click="$emit('change-category', item.value, index)">{{ item.text }}</div> -->
                <CategoryContent :item="item" :activeIndex="activeIndex" :index="index" @do-event="$emit('change-category', item.value, index)" />
            </swiper-slide>
        </template>

    </swiper>
    <div v-if="setting.navigation" @click="prev" class="swiper-button-prev" :class="{'swiper-button-disabled' : disablePrev}"></div>
    <div v-if="setting.navigation" @click="next" class="swiper-button-next" :class="{'swiper-button-disabled' : disableNext}"></div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { Navigation, Pagination, Scrollbar } from "swiper";

import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

import CategoryContent from './content/CategoryContent.vue';

// Import Swiper styles
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Scrollbar]);

export default {
  components: {
    Swiper,
    SwiperSlide,
    CategoryContent
  },
  props:{
    view: {
        type: Number,
        default: 1
    },
    activeIndex: {
        type: Number,
        default: 0
    },
    isType: {
        type: Boolean,
        default: true
    },
    breakpoints:{
        type: Object,
        default: () =>{}
    },
    data: {
        type: Array,

        default: []
    },
    content: {
        type: String,
        default: ''
    },
    setting:{
        type: Object,
        default(){
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: false,
                observeParents: true,
                observer: true,
                spaceBetween: 30,
                loop: false,
                pagination: true,
                navigation: true,
                scrollbar: true,
                breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 20,
                                    slidesPerGroup: 1
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                    slidesPerGroup: 2
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                    slidesPerGroup: 3
                                },
                                1200: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                    slidesPerGroup: 4
                                }
                            }
            };
        }
    }
  },
  data() {
    return {
      swiper: null,
      disableNext: false,
      disablePrev: false,
    };
  },
  created(){
   // console.log(this.data);
   // console.log((2500).toLocaleString()); /* $2,500.00 */
  },
  computed: {
     ...mapGetters({

            locale: "lang/locale"
        }),
  },
  updated() {



  },
  methods: {
    getImageUrl(imageId) {
      return `https://picsum.photos/600/400/?image=${imageId}`;
    },
    onSwiper(swiper) {

      this.swiper = swiper;
    },
    onSlideChange() {
     // this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
     // this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },
    next(){
        this.swiper.slideNext();
       // this.swiper.isEnd === true ? this.disableNext = true : this.disableNext = false;
      //  this.disablePrev = false;
    },
    prev(){

        this.swiper.slidePrev();
       // this.disableNext = false;
       // this.swiper.isBeginning === true ? this.disablePrev = true : this.disablePrev = false;
    },

    formatNumber(n){
        var x = Number(n)
        return (x).toLocaleString();
    },
    toSlug(str) {
        // Chuyển hết sang chữ thường
        str = str.toLowerCase();

        // xóa dấu
        str = str
            .normalize('NFD') // chuyển chuỗi sang unicode tổ hợp
            .replace(/[\u0300-\u036f]/g, ''); // xóa các ký tự dấu sau khi tách tổ hợp

        // Thay ký tự đĐ
        str = str.replace(/[đĐ]/g, 'd');

        // Xóa ký tự đặc biệt
        str = str.replace(/([^0-9a-z-\s])/g, '');

        // Xóa khoảng trắng thay bằng ký tự -
        str = str.replace(/(\s+)/g, '-');

        // Xóa ký tự - liên tiếp
        str = str.replace(/-+/g, '-');

        // xóa phần dư - ở đầu & cuối
        str = str.replace(/^-+|-+$/g, '');

        // return
        return str;
    },

    convertTitleToSlug(title, id){
        //let t = title.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, "-");

        return 'https://www.masterkorean.vn/course/' + this.toSlug(title) + '?courseid='+ id;
    }

  },
};
</script>

<style scoped>
.area-slides{
    /* border-radius: 50px; */
    /* background: linear-gradient(180deg, #F1F4FF 0%, rgba(174, 185, 208, 0.00) 100%); */
    padding: 10px 15px 0px;
    position: relative;
}
/* .swiper-slide{
    width: auto;
} */
.container {
  width: 100%;
  max-width: 100%;
  height: auto;
  overflow: hidden;
}

.swiper-container {
  width: 100%;
  height: 100%;
  overflow: inherit;
  padding-bottom: 10px;
}


.color-1{
    color: #75787B;
}
.color-2{
    color: #485CC7;
}
.color-3{
    color: #97999B;
}
.color-4{
    color: #F5222D;
}
.card-body{
    padding: 7px 12px 13px 12px;
}

.line-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* .card-img-top {
    height: auto;
    -o-object-fit: contain;
    object-fit: contain;
} */

</style>

<style>
.swiper-pagination-bullet{
    background: #ADC6FF;
    opacity: 1;
}
.swiper-pagination-bullet-active{
    width: 24px;
    border-radius: 4px;
    background: #485CC7;
}
.swiper-button-prev:after, .swiper-button-next:after{
    color: #808EB1;
    font-size: 27px;
    font-weight: bold;
    content: '';
    background: url('../../assets/images/Exam/next.png') center center no-repeat;
    width: 40px;
    height: 40px;
}
.swiper-button-prev:after{
    background: url('../../assets/images/Exam/prev.png') center center no-repeat;
}

</style>
